import AddOns from './AddOns';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withCart from '../../hocs/withCart';
import withProducts from '../../hocs/withProducts';
import withProductVariant from '../../hocs/withProductVariant';
import withSetupTracking from '../../hocs/withSetupTracking';
import { withAddOns, withActivePage, withAddonForm, withAddonLifecycle } from './hocs.js';
import { addFlashMessageNotice } from '../FlashMessages/duck';

const enhance = compose(
  connect(null, dispatch => ({
    flashMessage: message => message && dispatch(addFlashMessageNotice(message)),
  })),
  withCart,
  withProductVariant,
  withProducts,
  withSetupTracking,
  withAddOns,
  withActivePage,
  withAddonForm,
  withAddonLifecycle,
);

export default enhance(AddOns);



// WEBPACK FOOTER //
// ./src/client/js/view/components/AddOns/index.js